require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-teach-your-kids-to-code-with-flappy-bird.json") })
        }
      }, "path---blog-teach-your-kids-to-code-with-flappy-bird");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-teach-your-kids-to-code-with-flappy-bird!./.cache/json/blog-teach-your-kids-to-code-with-flappy-bird.json
// module id = 1101
// module chunks = 231608221292675